// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Staff_info__DsB\\+Z button {
  margin-top: auto;
}

.Staff_actions__ktdzd {
  margin-top: auto;
  padding-top: 20px;
}

.Staff_modalHeader__EB85G h3 {
  white-space: pre-line;
}

.Staff_staff__PMx9g {
  padding: clamp(4rem, 8vw, 6rem) 0;
  background: #f9fafb;
  text-align: center;
  /* =========================
     SECTION TITLE
  ========================= */
}
.Staff_staff__PMx9g h2 {
  font-size: clamp(1.4rem, 4vw, 2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: clamp(2rem, 5vw, 3rem);
  text-transform: uppercase;
}
.Staff_staff__PMx9g {
  /* =========================
     GRID
  ========================= */
}
.Staff_staff__PMx9g .Staff_grid__KS-O- {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(1.5rem, 4vw, 2rem);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
@media (max-width: 992px) {
  .Staff_staff__PMx9g .Staff_grid__KS-O- {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Staff_staff__PMx9g .Staff_grid__KS-O- {
  /* =========================
     MOBILE SIMPLE CARD
  ========================= */
}
@media (max-width: 640px) {
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA {
    text-align: center;
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA .Staff_info__DsB\\+Z {
    padding: 14px 6px 18px;
    align-items: center;
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- {
    /* ❌ թաքցնում ենք profession */
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA .Staff_info__DsB\\+Z h4 {
    display: none;
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- {
    /* ❌ թաքցնում ենք description */
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA .Staff_info__DsB\\+Z p {
    display: none;
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- {
    /* անունը կենտրոն */
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA .Staff_info__DsB\\+Z h3 {
    text-align: center;
    margin-bottom: 14px;
    font-size: 1rem;
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- {
    /* button full width + գեղեցիկ */
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA .Staff_actions__ktdzd {
    width: 100%;
  }
  .Staff_staff__PMx9g .Staff_grid__KS-O- .Staff_card__iGuvA .Staff_actions__ktdzd .Staff_btn__k7zC1 {
    width: 100%;
    justify-content: center;
    padding: 12px 16px;
    font-size: 0.95rem;
  }
}
.Staff_staff__PMx9g {
  /* =========================
     CARD
  ========================= */
}
.Staff_staff__PMx9g .Staff_card__iGuvA {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}
@media (hover: hover) {
  .Staff_staff__PMx9g .Staff_card__iGuvA:hover {
    transform: translateY(-6px);
    box-shadow: 0 14px 32px rgba(0, 0, 0, 0.12);
  }
}
.Staff_staff__PMx9g .Staff_card__iGuvA {
  /* IMAGE */
}
.Staff_staff__PMx9g .Staff_card__iGuvA img {
  width: 100%;
  aspect-ratio: 3/4;
  object-fit: cover;
  display: block;
}
.Staff_staff__PMx9g .Staff_card__iGuvA {
  /* INFO */
}
.Staff_staff__PMx9g .Staff_card__iGuvA .Staff_info__DsB\\+Z {
  padding: 24px;
  text-align: left;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.Staff_staff__PMx9g .Staff_card__iGuvA .Staff_info__DsB\\+Z h3 {
  color: #1e2150;
  font-weight: 700;
  font-size: clamp(1.1rem, 3vw, 1.25rem);
  margin-bottom: 4px;
}
.Staff_staff__PMx9g .Staff_card__iGuvA .Staff_info__DsB\\+Z h4 {
  color: #6b7280;
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  margin-bottom: 12px;
  font-weight: 500;
}
.Staff_staff__PMx9g .Staff_card__iGuvA .Staff_info__DsB\\+Z p {
  color: #555;
  font-size: clamp(0.9rem, 2.5vw, 0.95rem);
  line-height: 1.6;
  margin-bottom: 30px;
}
.Staff_staff__PMx9g {
  /* =========================
     MODAL OVERLAY
  ========================= */
}
.Staff_staff__PMx9g .Staff_modalOverlay__7\\+opB {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}
.Staff_staff__PMx9g {
  /* =========================
     MODAL
  ========================= */
}
.Staff_staff__PMx9g .Staff_modal__JdVIo {
  background: #fff;
  border-radius: 14px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: clamp(1.5rem, 4vw, 2.5rem);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  text-align: left;
  position: relative;
}
.Staff_staff__PMx9g .Staff_modal__JdVIo h3 {
  font-size: clamp(1.2rem, 4vw, 1.6rem);
  color: #1e2150;
  margin-bottom: 1rem;
  font-weight: 800;
}
.Staff_staff__PMx9g .Staff_modal__JdVIo p {
  color: #111827;
  line-height: 1.8;
  font-size: clamp(0.9rem, 3vw, 1rem);
}

/* =========================
   MODAL OVERLAY
========================= */
.Staff_modalOverlay__7\\+opB {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

/* =========================
   MODAL WINDOW
========================= */
.Staff_modal__JdVIo {
  background: #fff;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  animation: Staff_slideUp__I\\+GuE 0.3s ease;
}

/* =========================
   MODAL HEADER
========================= */
.Staff_modalHeader__EB85G {
  padding: 24px 28px;
  background: #f0f0f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Staff_modalHeader__EB85G h3 {
  font-size: 1.4rem;
  font-weight: 800;
  color: #1e2150;
  margin: 0;
}

/* CLOSE BUTTON */
.Staff_modalClose__A8QJl {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #1e2150;
  padding: 6px;
  line-height: 1;
  transition: transform 0.2s ease;
}
.Staff_modalClose__A8QJl:hover {
  transform: scale(1.1);
}

/* =========================
   MODAL BODY
========================= */
.Staff_modalBody__V8rBQ {
  padding: 28px;
  overflow-y: auto;
  line-height: 1.8;
  color: #111827;
  font-size: 1rem;
}
.Staff_modalBody__V8rBQ p {
  margin-bottom: 1.2rem;
}

/* =========================
   FOOTER
========================= */
.Staff_modalFooter__V9dmn {
  padding: 20px 28px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

/* =========================
   MOBILE
========================= */
@media (max-width: 576px) {
  .Staff_modal__JdVIo {
    border-radius: 12px;
  }
  .Staff_modalHeader__EB85G,
  .Staff_modalBody__V8rBQ,
  .Staff_modalFooter__V9dmn {
    padding: 20px;
  }
}
/* =========================
   ANIMATION
========================= */
@keyframes Staff_slideUp__I\\+GuE {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleAboutUs/Staff.module.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,gBAAA;AACF;;AAGA;EACE,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAEA;EACE,iCAAA;EACA,mBCeS;EDdT,kBAAA;EAEA;;6BAAA;AAEF;AACE;EACE,mCAAA;EACA,gBAAA;EACA,cCRS;EDST,qCAAA;EACA,yBAAA;AACJ;AAdA;EAgBE;;6BAAA;AAGF;AAAE;EACE,aAAA;EACA,qCAAA;EACA,6BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAEJ;AAAI;EARF;IASI,qCAAA;EAGJ;AACF;AAbE;EAYE;;6BAAA;AAMJ;AAHI;EAEE;IACE,kBAAA;EAIN;EADI;IACE,sBAAA;IACA,mBAAA;EAGN;EA1BA;IA0BI,8BAAA;EAGJ;EAFI;IACE,aAAA;EAIN;EAhCA;IA+BI,+BAAA;EAIJ;EAHI;IACE,aAAA;EAKN;EAtCA;IAoCI,mBAAA;EAKJ;EAJI;IACE,kBAAA;IACA,mBAAA;IACA,eAAA;EAMN;EA9CA;IA2CI,gCAAA;EAMJ;EALI;IACE,WAAA;EAON;EAJI;IACE,WAAA;IACA,uBAAA;IACA,kBAAA;IACA,kBAAA;EAMN;AACF;AA9EA;EA6EE;;6BAAA;AAMF;AAHE;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qDAAA;EACA,YAAA;AAKJ;AAHI;EACE;IACE,2BAAA;IACA,2CAAA;EAKN;AACF;AAnBE;EAiBE,UAAA;AAKJ;AAJI;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAMN;AA5BE;EAyBE,SAAA;AAMJ;AALI;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAON;AALM;EACE,cC/GK;EDgHL,gBAAA;EACA,sCAAA;EACA,kBAAA;AAOR;AAJM;EACE,cC5GD;ED6GC,qCAAA;EACA,mBAAA;EACA,gBAAA;AAMR;AAHM;EACE,WClHK;EDmHL,wCAAA;EACA,gBAAA;EACA,mBAAA;AAKR;AAxIA;EAyIE;;6BAAA;AAIF;AADE;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAGJ;AAvJA;EAuJE;;6BAAA;AAKF;AAFE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mCAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;AAIJ;AAFI;EACE,qCAAA;EACA,cCrKO;EDsKP,mBAAA;EACA,gBAAA;AAIN;AADI;EACE,cClKC;EDmKD,gBAAA;EACA,mCAAA;AAGN;;AAIA;;2BAAA;AAGA;EACE,eAAA;EACA,QAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AADF;;AAIA;;2BAAA;AAGA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AADF;;AAIA;;2BAAA;AAGA;EACE,kBAAA;EACA,mBCzMO;ED0MP,4CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cCjOS;EDkOT,SAAA;AADJ;;AAKA,iBAAA;AACA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cC5OW;ED6OX,YAAA;EACA,cAAA;EACA,+BAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;;AAMA;;2BAAA;AAGA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCpPK;EDqPL,eAAA;AAHF;AAKE;EACE,qBAAA;AAHJ;;AAOA;;2BAAA;AAGA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,yCAAA;AAJF;;AAOA;;2BAAA;AAGA;EACE;IACE,mBAAA;EAJF;EAOA;;;IAGE,aAAA;EALF;AACF;AAQA;;2BAAA;AAGA;EACE;IACE,UAAA;IACA,uCAAA;EANF;EAQA;IACE,UAAA;IACA,iCAAA;EANF;AACF","sourcesContent":["@use \"../variables\" as v;\r\n.info button {\r\n  margin-top: auto;\r\n\r\n}\r\n\r\n.actions {\r\n  margin-top: auto;\r\n  padding-top: 20px;\r\n\r\n}\r\n.modalHeader h3 {\r\n  white-space: pre-line;\r\n}\r\n.staff {\r\n  padding: clamp(4rem, 8vw, 6rem) 0;\r\n  background: v.$bg-light;\r\n  text-align: center;\r\n\r\n  /* =========================\r\n     SECTION TITLE\r\n  ========================= */\r\n  h2 {\r\n    font-size: clamp(1.4rem, 4vw, 2rem);\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n    margin-bottom: clamp(2rem, 5vw, 3rem);\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  /* =========================\r\n     GRID\r\n  ========================= */\r\n  .grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: clamp(1.5rem, 4vw, 2rem);\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 0 20px;\r\n\r\n    @media (max-width: 992px) {\r\n      grid-template-columns: repeat(2, 1fr);\r\n    }\r\n\r\n    /* =========================\r\n    MOBILE SIMPLE CARD\r\n ========================= */\r\n    @media (max-width: 640px) {\r\n\r\n      .card {\r\n        text-align: center;\r\n      }\r\n\r\n      .card .info {\r\n        padding: 14px 6px 18px;\r\n        align-items: center;\r\n      }\r\n\r\n      /* ❌ թաքցնում ենք profession */\r\n      .card .info h4 {\r\n        display: none;\r\n      }\r\n\r\n      /* ❌ թաքցնում ենք description */\r\n      .card .info p {\r\n        display: none;\r\n      }\r\n\r\n      /* անունը կենտրոն */\r\n      .card .info h3 {\r\n        text-align: center;\r\n        margin-bottom: 14px;\r\n        font-size: 1rem;\r\n      }\r\n\r\n      /* button full width + գեղեցիկ */\r\n      .card .actions {\r\n        width: 100%;\r\n      }\r\n\r\n      .card .actions .btn {\r\n        width: 100%;\r\n        justify-content: center;\r\n        padding: 12px 16px;\r\n        font-size: 0.95rem;\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  /* =========================\r\n     CARD\r\n  ========================= */\r\n  .card {\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n    height: 100%;\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        transform: translateY(-6px);\r\n        box-shadow: 0 14px 32px rgba(0, 0, 0, 0.12);\r\n      }\r\n    }\r\n\r\n    /* IMAGE */\r\n    img {\r\n      width: 100%;\r\n      aspect-ratio: 3 / 4;\r\n      object-fit: cover;\r\n      display: block;\r\n    }\r\n\r\n    /* INFO */\r\n    .info {\r\n      padding: 24px;\r\n      text-align: left;\r\n      display: flex;\r\n      flex-direction: column;\r\n      flex-grow: 1;\r\n\r\n      h3 {\r\n        color: v.$brand-blue;\r\n        font-weight: 700;\r\n        font-size: clamp(1.1rem, 3vw, 1.25rem);\r\n        margin-bottom: 4px;\r\n      }\r\n\r\n      h4 {\r\n        color: v.$gray;\r\n        font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n        margin-bottom: 12px;\r\n        font-weight: 500;\r\n      }\r\n\r\n      p {\r\n        color: v.$text-muted;\r\n        font-size: clamp(0.9rem, 2.5vw, 0.95rem);\r\n        line-height: 1.6;\r\n        margin-bottom: 30px;\r\n\r\n      }\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     MODAL OVERLAY\r\n  ========================= */\r\n  .modalOverlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.55);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    padding: 1rem;\r\n  }\r\n\r\n  /* =========================\r\n     MODAL\r\n  ========================= */\r\n  .modal {\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    max-width: 600px;\r\n    width: 100%;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    padding: clamp(1.5rem, 4vw, 2.5rem);\r\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\r\n    text-align: left;\r\n    position: relative;\r\n\r\n    h3 {\r\n      font-size: clamp(1.2rem, 4vw, 1.6rem);\r\n      color: v.$brand-blue;\r\n      margin-bottom: 1rem;\r\n      font-weight: 800;\r\n    }\r\n\r\n    p {\r\n      color: v.$dark;\r\n      line-height: 1.8;\r\n      font-size: clamp(0.9rem, 3vw, 1rem);\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n/* =========================\r\n   MODAL OVERLAY\r\n========================= */\r\n.modalOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(17, 24, 39, 0.6);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 1rem;\r\n}\r\n\r\n/* =========================\r\n   MODAL WINDOW\r\n========================= */\r\n.modal {\r\n  background: #fff;\r\n  width: 100%;\r\n  max-width: 640px;\r\n  max-height: 90vh;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideUp 0.3s ease;\r\n}\r\n\r\n/* =========================\r\n   MODAL HEADER\r\n========================= */\r\n.modalHeader {\r\n  padding: 24px 28px;\r\n  background: v.$bg-alt;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n\r\n  h3 {\r\n    font-size: 1.4rem;\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n/* CLOSE BUTTON */\r\n.modalClose {\r\n  background: none;\r\n  border: none;\r\n  font-size: 28px;\r\n  cursor: pointer;\r\n  color: v.$brand-blue;\r\n  padding: 6px;\r\n  line-height: 1;\r\n  transition: transform 0.2s ease;\r\n\r\n  &:hover {\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n/* =========================\r\n   MODAL BODY\r\n========================= */\r\n.modalBody {\r\n  padding: 28px;\r\n  overflow-y: auto;\r\n  line-height: 1.8;\r\n  color: v.$dark;\r\n  font-size: 1rem;\r\n\r\n  p {\r\n    margin-bottom: 1.2rem;\r\n  }\r\n}\r\n\r\n/* =========================\r\n   FOOTER\r\n========================= */\r\n.modalFooter {\r\n  padding: 20px 28px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* =========================\r\n   MOBILE\r\n========================= */\r\n@media (max-width: 576px) {\r\n  .modal {\r\n    border-radius: 12px;\r\n  }\r\n\r\n  .modalHeader,\r\n  .modalBody,\r\n  .modalFooter {\r\n    padding: 20px;\r\n  }\r\n}\r\n\r\n/* =========================\r\n   ANIMATION\r\n========================= */\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px) scale(0.96);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `Staff_info__DsB+Z`,
	"actions": `Staff_actions__ktdzd`,
	"modalHeader": `Staff_modalHeader__EB85G`,
	"staff": `Staff_staff__PMx9g`,
	"grid": `Staff_grid__KS-O-`,
	"card": `Staff_card__iGuvA`,
	"btn": `Staff_btn__k7zC1`,
	"modalOverlay": `Staff_modalOverlay__7+opB`,
	"modal": `Staff_modal__JdVIo`,
	"slideUp": `Staff_slideUp__I+GuE`,
	"modalClose": `Staff_modalClose__A8QJl`,
	"modalBody": `Staff_modalBody__V8rBQ`,
	"modalFooter": `Staff_modalFooter__V9dmn`
};
export default ___CSS_LOADER_EXPORT___;
